module.exports = __webpack_public_path__ + "img/mc_donald.f5cd722f.png";